
<script>
import http from '@/service/http'
import localforage from 'localforage'
import { mapState, mapActions } from 'vuex'
import decode from 'jwt-decode'

export default {
  name: 'RedefinirSenha',
  mounted () {
    this.hash = this.$router.currentRoute.query.hash
    this.email = this.$router.currentRoute.query.email
  },
  data () {
    return {
      email: '',
      password: '',
      hash: ''
    }
  },
  methods: {
    ...mapActions(['setToken', 'setPermissoes', 'setImagem']),
    async login () {
      try {
        const { email, password, hash } = this
        const response = await http.post(
          '/auth/redefinir-senha',
          { email, password, hash })
        const token = response.data.token
        const permissoes = response.data.permissoes
        const decoded = decode(token)
        const imagem = decoded.user.imagem
        if (imagem) {
          localforage.setItem('imagem', imagem)
        }
        localforage.setItem('permissoes', permissoes)
        localforage.setItem('token', token).then((token) => {
          this.setToken({ token })
          this.setPermissoes({ permissoes })
          this.setImagem({ imagem })
          this.$router.push({ name: 'dashboard' })
        })
      } catch (error) {
        console.log(error)
      }
    }
  },
  computed: {
    ...mapState(['loading'])
  }
}
</script>

<template>
	<div class="box-login">

    <br clear="all" />

    <div class="row">

      <div class="col s10 offset-s1 m6 offset-m3 l4 offset-l4">

        <form @submit.prevent="login()">

          <div class="card white" style="background: rgba(255,255,255,0.90) !important">
            <div class="card-content center-align">
              
              <img src="../../assets/images/logo-login.png">
              
              <br clear="all" />
              
              <span class="card-title center-align">Defina sua senha</span>

              <div class="row">
                <div class="input-field col s12">
                  <input type="email" id="email" v-model="email" required="required">
                  <label for="email">E-mail de cadastro</label>
                </div>
                <div class="input-field col s12">
                  <input type="password" id="password" v-model="password" required="required">
                  <label for="password">Nova senha</label>
                </div>
                <div class="input-field col s12 center-align">
                  <button type="submit" class="waves-effect waves-light btn" :disabled="loading">Redefinir Senha</button>
                </div>
              </div>

            </div>
          </div>

        </form>

      </div>

    </div>

  </div>
</template>

<style scoped>

.box-login{
  position: fixed;
  width: 100%;
  height: 100%;
  background: url('../../assets/images/bg-login.jpg') no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

</style>



// WEBPACK FOOTER //
// src/features/auth/redefinir-senha.vue